import * as types from './mutation-types'

export const decrementMain = ({ commit }) => {
  commit(types.DECREMENT_MAIN_COUNTER)
}

export const incrementMain = ({ commit }) => {
  commit(types.INCREMENT_MAIN_COUNTER)
}

export const nextStep = ({ commit }) => {
  commit(types.NEXT_STEP)
}

export const prevStep = ({ commit }) => {
  commit(types.PREV_STEP)
}

export const goStep = ({ commit }) => {
  commit(types.GO_STEP)
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js